<div class="after-sales-doc-upload-container">
  <div class="upload-header" fxLayout="row" fxLayoutAlign="space-between center">
    <span class="upload-title">
      <mat-icon class="title-icon">attach_file</mat-icon>
      Attached Documents / Files
    </span>
    <span class="file-count" *ngIf="fileList.length > 0">
      {{ fileList.length }} {{ fileList.length === 1 ? 'file' : 'files' }} attached
    </span>
  </div>

  <!-- Drag & Drop Zone -->
  <div class="doc-drop-zone" [ngClass]="{'drop-zone-active': hasBaseDropZoneOver}" ng2FileDrop [uploader]="uploader"
    (fileOver)="fileOverBase($event)" (click)="fileInput.click()">
    <input #fileInput type="file" ng2FileSelect [uploader]="uploader" multiple hidden
      accept=".pdf,.doc,.docx,.xls,.xlsx,.csv,.ppt,.pptx,.jpg,.jpeg,.png,.gif,.svg,.webp,.bmp,.mp4,.avi,.mov,.wmv,.mkv,.webm,.mp3,.wav,.ogg,.m4a,.flac,.txt,.log,.rtf" />

    <div class="drop-zone-content">
      <div class="drop-icon-wrap">
        <mat-icon class="cloud-icon">cloud_upload</mat-icon>
      </div>
      <div class="drop-text-primary">
        <span class="browse-link">Click to upload</span> or drag and drop documents
      </div>
      <div class="drop-text-secondary">
        Supports PDF, DOC, DOCX, XLS, XLSX, PPT, Images, Video, Audio, Text (Max 16 MB each)
      </div>
    </div>
  </div>

  <!-- Progress Bar -->
  <div class="progress-wrap" *ngIf="uploadInProgress">
    <div class="progress-label" fxLayout="row" fxLayoutAlign="space-between center">
      <span>Uploading files...</span>
      <span>Please wait</span>
    </div>
    <mat-progress-bar mode="indeterminate" color="primary"></mat-progress-bar>
  </div>

  <!-- Attached Files List -->
  <div class="attached-files-list" *ngIf="fileList.length > 0">
    <div class="list-header" fxLayout="row" fxLayoutAlign="space-between center">
      <span class="list-heading">Uploaded Documents ({{ fileList.length }})</span>
      <button mat-button color="warn" class="clear-all-btn" (click)="removeAllFiles($event)">
        <mat-icon style="font-size: 16px; width: 16px; height: 16px;">delete_sweep</mat-icon>
        Remove All
      </button>
    </div>

    <div class="file-cards-grid">
      <div class="file-card" *ngFor="let item of fileList; let i = index">
        <div class="file-card-inner" fxLayout="row" fxLayoutAlign="space-between center">

          <div class="file-info" fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="12px">
            <div class="file-type-badge" [ngClass]="getFileBadgeClass(item.name || item.fileName)">
              <mat-icon>{{ getFileIcon(item.name || item.fileName) }}</mat-icon>
            </div>

            <div class="file-details" fxLayout="column">
              <a *ngIf="item.uploaded && item.serverFileName" (click)="openPreviewDialog(item, $event)"
                class="file-name link" style="cursor: pointer;" [title]="item.name || item.fileName">
                {{ item.name || item.fileName }}
              </a>
              <span *ngIf="!item.uploaded || !item.serverFileName" class="file-name"
                [title]="item.name || item.fileName">
                {{ item.name || item.fileName }}
              </span>

              <span class="file-meta">
                <span *ngIf="item.size">{{ formatFileSize(item.size) }}</span>
                <span *ngIf="item.size && item.uploaded" class="meta-dot">•</span>
                <span *ngIf="item.uploaded" class="status-uploaded">
                  <mat-icon class="check-icon">check_circle</mat-icon> Uploaded
                </span>
                <span *ngIf="item.uploading" class="status-uploading">
                  <mat-progress-spinner mode="indeterminate" diameter="12"></mat-progress-spinner> Uploading...
                </span>
              </span>
            </div>
          </div>

          <div class="file-actions" fxLayout="row" fxLayoutAlign="end center" fxLayoutGap="4px">
            <button *ngIf="item.uploaded && item.serverFileName" type="button" mat-icon-button class="preview-btn"
              title="Preview File" (click)="openPreviewDialog(item, $event)">
              <mat-icon style="font-size: 18px; width: 18px; height: 18px;">open_in_new</mat-icon>
            </button>
            <button mat-icon-button color="warn" class="delete-btn" (click)="removeFile(i, $event)" title="Remove">
              <mat-icon style="font-size: 18px; width: 18px; height: 18px;">close</mat-icon>
            </button>
          </div>

        </div>
      </div>
    </div>
  </div>
</div>

<!-- Preview Dialog Template -->
<ng-template #previewDialog>
  <div class="after-sales-preview-modal" style="display: flex; flex-direction: column; max-height: 85vh;">
    <div class="modal-header" fxLayout="row" fxLayoutAlign="space-between center"
      style="padding: 14px 20px; border-bottom: 1px solid #e2e8f0; background: #f8fafc;">
      <span class="modal-title" style="font-weight: 600; font-size: 16px; color: #1e293b; overflow: hidden; text-overflow: ellipsis; white-space: nowrap; max-width: 85%;">
        <mat-icon style="vertical-align: middle; margin-right: 6px; color: #3b82f6;">visibility</mat-icon>
        {{ selectedPreviewFile?.name || selectedPreviewFile?.serverFileName }}
      </span>
      <button mat-icon-button (click)="closePreviewDialog()" type="button" style="color: #64748b;">
        <mat-icon>close</mat-icon>
      </button>
    </div>

    <div class="modal-body" style="padding: 20px; overflow-y: auto; text-align: center; flex: 1; background: #ffffff;">
      <!-- Image Preview -->
      <div *ngIf="isImageFile(selectedPreviewFile?.name || selectedPreviewFile?.serverFileName)" style="display: flex; justify-content: center; align-items: center;">
        <calsoft-common-images [src]="selectedPreviewUrl" width="100%" height="auto"></calsoft-common-images>
      </div>

      <!-- PDF Preview -->
      <div *ngIf="isPdfFile(selectedPreviewFile?.name || selectedPreviewFile?.serverFileName)" style="width: 100%;">
        <iframe *ngIf="selectedPreviewSafeUrl" [src]="selectedPreviewSafeUrl" width="100%" height="480px" style="border: 1px solid #cbd5e1; border-radius: 6px;"></iframe>
      </div>

      <!-- Video Preview -->
      <div *ngIf="isVideoFile(selectedPreviewFile?.name || selectedPreviewFile?.serverFileName)">
        <video controls [src]="selectedPreviewFullUrl" style="max-width: 100%; max-height: 480px; border-radius: 6px;"></video>
      </div>

      <!-- Audio Preview -->
      <div *ngIf="isAudioFile(selectedPreviewFile?.name || selectedPreviewFile?.serverFileName)" style="padding: 20px 0;">
        <audio controls [src]="selectedPreviewFullUrl" style="width: 100%;"></audio>
      </div>

      <!-- Other Documents Preview -->
      <div *ngIf="!isImageFile(selectedPreviewFile?.name || selectedPreviewFile?.serverFileName) && !isPdfFile(selectedPreviewFile?.name || selectedPreviewFile?.serverFileName) && !isVideoFile(selectedPreviewFile?.name || selectedPreviewFile?.serverFileName) && !isAudioFile(selectedPreviewFile?.name || selectedPreviewFile?.serverFileName)">
        <calsoft-common-images [src]="selectedPreviewUrl" width="100%" height="auto"></calsoft-common-images>
      </div>
    </div>

    <div class="modal-footer" fxLayout="row" fxLayoutAlign="space-between center"
      style="padding: 12px 20px; border-top: 1px solid #e2e8f0; background: #f8fafc;">
      <a [href]="selectedPreviewFullUrl" target="_blank" download mat-stroked-button color="primary">
        <mat-icon style="font-size: 18px; width: 18px; height: 18px; margin-right: 4px;">cloud_download</mat-icon>
        Download
      </a>
      <button mat-raised-button color="warn" (click)="closePreviewDialog()" type="button">
        Cancel
      </button>
    </div>
  </div>
</ng-template>